/**
 * Open support for phone-OTP dead ends (WhatsApp first, mailto fallback).
 * Shared by login / verify / link-phone so the hand-off never silently no-ops.
 *
 * Deliberately carries NO phone number in the message URL — auth screens
 * already refuse to put numbers in router params / logs; prefilling wa.me
 * with a phone would leak it the same way.
 */
import { Linking } from 'react-native'
import { BRAND } from '../brand'
import { toast } from '../toast'
import { captureError } from '../utils/observability'

function buildSupportUrl(message: string): string | null {
  const whatsapp = BRAND.contact.whatsappLink?.trim()
  if (whatsapp) return `${whatsapp}?text=${encodeURIComponent(message)}`
  const email = BRAND.contact.email?.trim()
  if (email) return `mailto:${email}?body=${encodeURIComponent(message)}`
  return null
}

export async function openPhoneOtpSupport(
  message: string,
  opts?: {
    /** Shown when no channel is configured, or Linking fails. */
    unavailableMessage?: string
    screen?: string
  },
): Promise<boolean> {
  const url = buildSupportUrl(message)
  if (!url) {
    if (opts?.unavailableMessage) toast.error(opts.unavailableMessage)
    return false
  }

  try {
    await Linking.openURL(url)
    return true
  } catch (err) {
    captureError(err, {
      screen: opts?.screen ?? 'phone-otp-support',
      action: 'open-support',
    })
    if (opts?.unavailableMessage) toast.error(opts.unavailableMessage)
    return false
  }
}
